var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.43451 1.43433C1.74693 1.12191 2.25346 1.12191 2.56588 1.43433L6.0002 4.86864L9.43451 1.43433C9.74693 1.12191 10.2535 1.12191 10.5659 1.43433C10.8783 1.74675 10.8783 2.25328 10.5659 2.5657L7.13157 6.00001L10.5659 9.43433C10.8783 9.74675 10.8783 10.2533 10.5659 10.5657C10.2535 10.8781 9.74693 10.8781 9.43451 10.5657L6.0002 7.13138L2.56588 10.5657C2.25346 10.8781 1.74693 10.8781 1.43451 10.5657C1.12209 10.2533 1.12209 9.74675 1.43451 9.43433L4.86882 6.00001L1.43451 2.5657C1.12209 2.25328 1.12209 1.74675 1.43451 1.43433Z",
    fill: "#303036",
    stroke: "#303036",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.aa6ea361abf1fc21fd711b633a5fc32e.svg";
export { ForwardRef as ReactComponent };